export const getEntraErrorMessage = function ($t, e, context = 'connection') {
  const status = e && e.response && e.response.status;

  if (status === 409) {
    return context === 'provider'
      ? $t('settings.entraErrors.providerAlreadyExists')
      : $t('settings.entraErrors.connectionAlreadyExists');
  }
  if (status === 403) {
    return $t('settings.entraErrors.forbidden');
  }
  if (status === 404) {
    return $t('settings.entraErrors.notFound');
  }
  if (status === 412 || status === 424) {
    return $t('settings.entraErrors.registrationMissing');
  }
  if (status === 400 || status === 502 || status === 503 || status === 504) {
    return $t('settings.entraErrors.connectionFailed');
  }

  return $t('settings.entraErrors.generic');
};
